import { renderWithLoader } from '@meteor/data-hooks';
import { DataList, Heading, Table } from '@radix-ui/themes';
import { useParams } from 'react-router-dom';
import { agentTemplateState } from '../../../state';

export let AgentTemplatePage = () => {
  let { agentTemplateId } = useParams();
  let agentTemplate = agentTemplateState.use({ id: agentTemplateId! });

  return renderWithLoader({ agentTemplate })(({ agentTemplate }) => (
    <>
      <Heading as="h1" size="7">
        {agentTemplate.data.name}
      </Heading>

      <Heading as="h2" size="4" style={{ marginBottom: 10, marginTop: 20 }}>
        Agent Template Details
      </Heading>

      <DataList.Root>
        {[
          ['Id', agentTemplate.data.id],
          ['Name', agentTemplate.data.name],
          ['Description', agentTemplate.data.description],
          ['Created At', agentTemplate.data.createdAt.toLocaleDateString('de-at')],
          ['Updated At', agentTemplate.data.updatedAt.toLocaleDateString('de-at')]
        ].map(([label, value]) => (
          <DataList.Item key={label}>
            <DataList.Label>{label}</DataList.Label>
            <DataList.Value>{value}</DataList.Value>
          </DataList.Item>
        ))}
      </DataList.Root>
    </>
  ));
};
